import { useCallback } from 'react';

import { Typography } from 'antd';

import BaseCard from '@/components/shared/BaseCard';
import NotesProps from '@/interfaces/notes';
import { StyledProp } from '@/styled';

import { useNotes } from '../context';

interface NotesCardProps extends StyledProp, NotesProps {}

const NotesCard = (data: NotesCardProps) => {
  const { setCurrentNote } = useNotes();

  const { lesson, course, image } = data;

  const handleClick = useCallback(() => setCurrentNote(data), [data, setCurrentNote]);

  return (
    <BaseCard internalSpace={16} image={{ src: image, aspect: '16:9', onClick: handleClick }}>
      <Typography.Text strong onClick={handleClick} ellipsis>
        {lesson?.title ?? 'Título da aula'}
      </Typography.Text>

      <Typography.Text type='secondary' ellipsis>
        {course?.title ?? 'Nome do curso'}
      </Typography.Text>
    </BaseCard>
  );
};

export default NotesCard;
